import { render, staticRenderFns } from "./CurrentOperations.vue?vue&type=template&id=2130c0f1&scoped=true&"
import script from "./CurrentOperations.vue?vue&type=script&lang=js&"
export * from "./CurrentOperations.vue?vue&type=script&lang=js&"
import style0 from "./CurrentOperations.vue?vue&type=style&index=0&id=2130c0f1&scoped=true&lang=css&"
import style1 from "./CurrentOperations.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2130c0f1",
  null
  
)

export default component.exports